module.exports = __webpack_public_path__ + "static/img/collection3.0358d252.png";